<app-nav></app-nav>
<div class="container mt-5">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="invitation-container">
        <h2 class="text-center mb-4">📨 Invite Friends to Join</h2>

        <!-- Simple Instructions -->
        <div class="simple-guide mb-4">
          <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
              <h5>Generate Your Invitation Link</h5>
              <p>Create a unique link that's valid for 30 days</p>
            </div>
          </div>
          <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
              <h5>Copy & Share</h5>
              <p>Copy the link and share it via WhatsApp, SMS, Email, or any app</p>
            </div>
          </div>
          <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
              <h5>Track Invitations</h5>
              <p>See how many friends accepted your invitation</p>
            </div>
          </div>
        </div>

        <!-- Current Invitation Status -->
        <div *ngIf="hasActiveToken" class="current-invitation mb-4">
          <h4><i class="bi bi-link"></i> Your Current Invitation</h4>
          
          <div class="invitation-details">
            <div class="detail-item">
              <span class="label">Link:</span>
              <div class="link-container">
                <code class="invitation-link">{{ inviteLink }}</code>
                <button (click)="copyLink()" class="copy-btn">
                  <i class="bi bi-clipboard"></i> Copy
                </button>
              </div>
            </div>
            
            <div class="detail-item">
              <span class="label">Expires:</span>
              <span class="value">{{ expiresAt | date:'mediumDate' }} ({{ getDaysRemaining() }} days left)</span>
            </div>
            
            <div class="stats">
              <div class="stat">
                <span class="stat-number">{{ invitationsSent }}</span>
                <span class="stat-label">Sent</span>
              </div>
              <div class="stat">
                <span class="stat-number">{{ invitationsAccepted }}</span>
                <span class="stat-label">Accepted</span>
              </div>
            </div>
            
            <div class="share-note">
              <p><strong>How to share:</strong> Copy the link above and paste it in WhatsApp, SMS, Email, Facebook Messenger, or any other messaging app.</p>
            </div>
            
            <div class="actions">
              <button (click)="generateNewInvite()" class="btn-new">
                <i class="bi bi-arrow-repeat"></i> Create New Link
              </button>
            </div>
          </div>
        </div>

        <!-- Generate Link Section -->
        <div *ngIf="!hasActiveToken" class="generate-section mb-4">
          <div class="text-center">
            <h4><i class="bi bi-plus-circle"></i> Create Your First Invitation Link</h4>
            <p class="text-muted mb-3">Generate a link that you can share with friends</p>
            <button (click)="generateInvite()" [disabled]="loading" class="btn-generate">
              <span *ngIf="loading"><i class="bi bi-arrow-clockwise spin"></i> Creating...</span>
              <span *ngIf="!loading"><i class="bi bi-link-45deg"></i> Generate Link</span>
            </button>
          </div>
        </div>

        <!-- Send Email Invitation (Optional) -->
        <div class="email-section">
          <div class="section-header">
            <h5><i class="bi bi-envelope"></i> Or Send Direct Email Invitation</h5>
            <small class="text-muted">Optional - You can also send invitations directly via email</small>
          </div>
          
          <div class="email-form">
            <div class="alert alert-info mb-3">
              <i class="bi bi-info-circle"></i> 
              <strong>Already have a link?</strong> Just copy it from above and share anywhere. 
              Or use this form to send a professional email invitation.
            </div>
            
            <form [formGroup]="inviteForm">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Friend's Email</label>
                  <input 
                    type="email" 
                    formControlName="friend_email"
                    placeholder="friend@example.com"
                    class="form-control"
                  >
                </div>
                
                <div class="col-md-6 mb-3">
                  <label>Invitation Link</label>
                  <div class="input-group">
                    <input 
                      type="text" 
                      [value]="inviteLink || 'Generate a link first'"
                      readonly
                      class="form-control"
                    >
                    <button 
                      type="button" 
                      (click)="copyLink()" 
                      [disabled]="!inviteLink"
                      class="btn btn-outline-secondary"
                    >
                      <i class="bi bi-clipboard"></i>
                    </button>
                  </div>
                </div>
              </div>
              
              <div class="d-flex gap-2">
                <button 
                  type="button" 
                  (click)="generateInvite()" 
                  [disabled]="loading || !canGenerate"
                  class="btn btn-outline-primary"
                >
                <i class="bi bi-link"></i> {{ loading ? 'Generating...' : 'Generate Link' }}
                
                </button>
                
                <button 
                  type="button" 
                  (click)="sendInvite()" 
                  [disabled]="loading || !inviteForm.valid || !hasActiveToken"
                  class="btn btn-primary flex-grow-1"
                >
                  <span *ngIf="!loading">
                    <i class="bi bi-send"></i> Send Email Invitation
                  </span>
                  <span *ngIf="loading">
                    <i class="bi bi-arrow-clockwise spin"></i> Sending...
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Sharing Tips -->
        <div class="tips-section mt-4 mb-5">
          <h6><i class="bi bi-lightbulb"></i> Sharing Tips:</h6>
          <ul class="tips-list">
            <li>✓ <strong>WhatsApp:</strong> Just paste the link in any chat</li>
            <li>✓ <strong>SMS:</strong> Copy and paste in your message app</li>
            <li>✓ <strong>Email:</strong> Paste the link in email body</li>
            <li>✓ <strong>Social Media:</strong> Share in Facebook, Instagram, etc.</li>
            <li>✓ <strong>Anywhere:</strong> The link works on all platforms</li>
          </ul>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="loading-indicator">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Processing...</p>
        </div>
      </div>
    </div>
  </div>
</div>